import React from 'react';
import { Svg } from '../../index'
import styles from '../AccountingBookLabel/accountingBookLabel.module.scss'

const AccountingBookDeletedLabel = (props) => {
  return (
    <div className={styles.deletedCard} onClick={props.clicked}>
      <span className={styles.deletedIcon}>
        <Svg icon='delete' size='20' className='gray900' />
      </span>
      <span className={styles.deletedText}>刪除的帳本</span>
      <span className={styles.deletedChevron}>
        <Svg icon='rightArrow' color='black' size='18' />
      </span>
    </div>
  )
};

export default AccountingBookDeletedLabel;
